const initialState = {
  loading: false,
  submitting: false,
  successful: false,
  drivers: [],
  driver: null,
}

export default function (state = initialState, action = {}) {
  switch (action.type) {
    case 'GET_DOCUMENT_DRIVERS': {
      return {
        ...state,
        loading: true
      }
    }

    case 'GET_DOCUMENT_DRIVERS_COMMIT': {
      return {
        ...state,
        loading: false,
        drivers: action.payload.drivers
      }
    }

    case 'GET_DOCUMENT_DRIVERS_ROLLBACK': {
      return {
        ...state,
        loading: false,
        drivers: initialState.drivers,
      }
    }

    case 'ADD_DOCUMENT_DRIVER': {
      return {
        ...state,
        submitting: true,
        successful: false,
      }
    }

    case 'ADD_DOCUMENT_DRIVER_COMMIT': {
      return {
        ...state,
        submitting: false,
        successful: true
      }
    }

    case 'ADD_DOCUMENT_DRIVER_ROLLBACK': {
      return {
        ...state,
        submitting: false,
        successful: false
      }
    }

    case 'REMOVE_DOCUMENT_DRIVER': {
      return {
        ...state,
        submitting: true,
        successful: false
      }
    }

    case 'REMOVE_DOCUMENT_DRIVER_COMMIT': {
      return {
        ...state,
        submitting: false,
        successful: true,
      }
    }

    case 'REMOVE_DOCUMENT_DRIVER_ROLLBACK': {
      return {
        ...state,
        successful: false,
        submitting: false,
      }
    }

    case 'SET_DOCUMENT_DRIVER': {
      return {
        ...state,
        driver: action.payload.driver,
      }
    }

    default: {
      return state
    }
  }
}
